import { SerializationContext, DataModelBuilder, SerializedData, cloneList, isSameList } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ServiceStaffMembersComponent extends Component {
  static readonly TYPE_ID: string = '90d814a79fd543d98cc9e36cff8feb95';

  constructor(
    public readonly staffMembers: string[],
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return ServiceStaffMembersComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ServiceStaffMembersComponent {
    return new ServiceStaffMembersComponent(
        MapUtils.getList<string>(map, 'staffMembers', (value) => value as string),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'staffMembers': this.staffMembers,
    };
  }

  clone(): this {
    return new ServiceStaffMembersComponent(
        cloneList(this.staffMembers),
    ) as this;
  }
  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.staffMembers, this.staffMembers);
  }
}

export class ServiceStaffMembersComponentBuilder extends DataModelBuilder<ServiceStaffMembersComponent> {
  build(context: SerializationContext, map: SerializedData): ServiceStaffMembersComponent {
    return ServiceStaffMembersComponent.fromMap(context, map);
  }
}
